import { render, staticRenderFns } from "./EditActivityGoods.vue?vue&type=template&id=45b15f69&scoped=true&"
import script from "./EditActivityGoods.vue?vue&type=script&lang=js&"
export * from "./EditActivityGoods.vue?vue&type=script&lang=js&"
import style0 from "./EditActivityGoods.vue?vue&type=style&index=0&id=45b15f69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b15f69",
  null
  
)

export default component.exports